'use strict';
module.exports = function (obj) {
	var ret = {};
	var keys = Object.keys(Object(obj));

	for (var i = 0; i < keys.length; i++) {
		ret[keys[i].toLowerCase()] = obj[keys[i]];
	}

	return ret;
};



//////////////////
// WEBPACK FOOTER
// ./~/lowercase-keys/index.js
// module id = 951
// module chunks = 0 1 2 3